export default {
  special: {
    Year: 'XX年', // 年
    Th: 'XX号', // 号
    '01月': '01月', // 一月
    '02月': '02月', // 二月
    '03月': '03月', // 三月
    '04月': '04月', // 四月
    '05月': '05月', // 五月
    '06月': '06月', // 六月
    '07月': '07月', // 七月
    '08月': '08月', // 八月
    '09月': '09月', // 九月
    '10月': '10月', // 十月
    '11月': '11月', // 十一月
    '12月': '12月', // 十二月
  },
  common: {
    pleaseEnter: '请输入内容',
    passLogin: '密码登录',
    switchSuccess: '切换成功',
    login: '登录',
    Cancel: '取消', // 取消
    Clear: '清空', // 清空
    Search: '搜索', // 搜索
    TurnOn: '开启', // 开启
    Close: '关闭', // 关闭
    Time: '时间', // 时间
    Download: '下载', // 下载
    Edit: '修改', // 修改
    Delete: '删除', // 删除
    Save: '保存', // 保存
    Agree: '同意', // 同意
    Deny: '拒绝', // 拒绝
    Ok: '确定', // 确定
    Language: '语言', // 语言
    Chinese: '中文', // 中文
    English: '英文', // 英文
    Link: '链接', // 链接
    Year: '年', // 年
    PleaseFillAccount: '请填写账号', // 请填写账号
    Apply: '申请', // 申请
    Permission: '权限', // 权限
    DateFormat: 'yyyy年MM月dd日 HH:mm', // yyyy年MM月dd日 HH:mm
    Hour: '小时', // 小时
    Minute: '分', // 分
    Second: '秒', // 秒
    Grant: '授予', // 授予
    PermissionsSucc: '权限成功', // 权限成功
    PermissionsFail: '权限失败', // 权限失败
    Upload: '上传', // 上传
    Today: '今天', // 今天
    Jan: '一月', // 一月
    Feb: '二月', // 二月
    Mar: '三月', // 三月
    Apr: '四月', // 四月
    May: '五月', // 五月
    Jun: '六月', // 六月
    Jul: '七月', // 七月
    Aug: '八月', // 八月
    Sept: '九月', // 九月
    Oct: '十月', // 十月
    Nov: '十一月', // 十一月
    Dec: '十二月', // 十二月
    People: 'XX人', // XX人
    Loading: '加载中', // 加载中
    Next: '下一步', // 下一步
  },
  login: {
    LoginWithPassword: '密码登录', // 密码登录
    phoneUserEmail: '手机号/用户名/邮箱', // 手机号/用户名/邮箱
    Password: '密码', // 密码
    LogIn: '登录', // 登录
    Registration: '免费注册', // 免费注册
    ThirdPartyLogin: '第三方登录', // 第三方登录
    Interconnected: '飞象互联', // 飞象互联
    AccountNotExist: '账户不存在', // 账户不存在
    InvalidPassword: '密码错误', // 密码错误
    Second: '秒', // 秒
    NetworkNotConnected: '网络未连接，请连接后重试', // 网络未连接，请连接后重试
    AccountError: '账号输入错误', // 账号输入错误
    PasswordError: '密码输入错误', // 密码输入错误
    PhonenumberNotValid: '请输入正确的手机号', // 请输入正确的手机号
    PasswordLess6Char: '密码至少6位', // 密码至少6位
    PasswordMore18Char: '密码最多18位', // 密码最多18位
    CheckPrivacyPolicy: '请勾选隐私协议', // 请勾选隐私协议
    NameMore16Char: '姓名不能超过16个字符', // 姓名不能超过16个字符
    NameLess2Char: '姓名至少2个字符', // 姓名至少2个字符
    NameNotSpace: '姓名首尾不能有空格', // 姓名首尾不能有空格
    EnterPhoneNumber: '请输入手机号码', // 请输入手机号码
    RegisterSucc: '注册成功', // 注册成功
    PasswordFormat: '密码只能包含大小写字母、数字、_、=、@', // 密码只能包含大小写字母、数字、_、=、@
    GetGraphicVerifyFailed: '获取图形验证码失败，请重试', // 获取图形验证码失败，请重试
    ReadAgreed: '我已阅读并同意', // 我已阅读并同意
    UserServiceAgreement: '《用户服务协议》', // 《用户服务协议》
    ServiceAgreement: '服务协议', // 用户服务协议
    and: '和', // 和
    PrivacyPolicy: '《隐私政策》', // 隐私政策
    PrivacyPolicyNo: '隐私政策', // 隐私政策
    version: '版本', // 版本
    AgreementDescription1: '', // 拼接成完整的话
    AgreementDescription2: ' 内容更新，为了保护您的合法权益，请充分阅读并同意后，继续操作。', // 拼接成完整的话
    AgreeContinue: '同意并继续', // 同意并继续
    Disagree: '不同意', // 不同意
  },
  register: {
    EnterYourPhoneMumber: '请输入手机号', // 请输入手机号
    EnterVerificationCode: '请输入验证码', // 请输入验证码
    GetVerificationCode: '获取验证码', // 获取验证码
    VerificationCode: '图形验证码', // 图形验证码
    EnterVerificationCode1: '请输入图形验证码', // 请输入图形验证码
    ChangeOne: '换一张', // 换一张
    EnterPassword: '请输入密码', // 请输入密码
    ConfirmPassword: '请再次确认密码', // 请再次确认密码
    EnterUsername: '请输入姓名', // 请输入姓名
    MeansAgreeingAgreement: '注册即表示同意', // 注册即表示同意
    ServiceAgreement: 'HiLeia服务协议', // HiLeia服务协议
    Back: '返回登录', // 返回登录
    SignUp: '注册', // 注册
    VerificationCodeNotExist: '验证码不存在或已过期', // 验证码不存在或已过期
    EnterCorrectVerificationCode: '请输入正确的图形验证码', // 请输入正确的图形验证码
    Password6Characters: '密码至少6位', // 密码至少6位
    EnterPasswordNotMatch: '密码不一致', // 密码不一致
    Reacquire: '后重新获取', // 后重新获取
  },
  forgot: {
    EnterPhoneNumber: '输入手机号码', // 输入手机号码
    ForgotPassword: '忘记密码？', // 忘记密码
    SetNewPassword: '设置新密码', // 设置新密码
    SetPasswordSucc: '密码设置成功', // 密码设置成功
  },
  home: {
    MoreHowManyCollaborators: '协作人数上限', // 协作人数上限
    NotAddTypeOfExist: '已有该类型，无法添加', // 已有该类型，无法添加
    AddTypeSucc: '类型添加成功', // 类型添加成功
    More5Types: '最多选5个类型', // 最多选5个类型
    Cooperation: '协作', // 协作
    Appointment: '预约协作', // 预约协作
    ScheduleOfAppointmentCollaboration: '预约协作日程', // 预约协作日程
    AppointmentNow: '立即预约', // 立即预约
    Theme: '主题', // 主题
    CollaborationCreatedOf: 'XX创建的协作', // XX创建的协作
    StartingTime: '开始时间', // 开始时间
    PleaseSelectDate: '请选择日期', // 请选择日期
    EndTime: '结束时间', // 结束时间
    Type: '类型', // 类型
    PleaseAddType: '请添加类型', // 请添加类型
    AddType: '添加类型', // 添加类型
    EnteType: '请输入类型', // 请输入类型
    Collaborator: '协作方', // 协作方
    AddPhoneAndUsername: '通过手机号、用户名添加', // 通过手机号、用户名添加
    Contacts: '联系人', // 联系人
    ContactsSelected: '已选XX个联系人', // 已选X个联系人
    Host: '主持人', // 主持人
    MemberJoinMute: '成员入会静音', // 成员入会静音
    Attachment: '附件', // 附件
    UploadAttachment: '上传附件', // 上传附件
    CancelAppointment: '取消预约', // 取消预约
    ModifiedContentContinueExit: '修改内容未保存，是否继续退出', // 修改内容未保存，是否继续退出
    AppointmentSucc: '预约成功', // 预约成功
    AddCalendar: '添加到日历', // 添加到日历
    ViewDetails: '查看详情', // 查看详情
    CopyInvitationLink: '复制邀请链接', // 复制邀请链接
    CollaborateNow: '立即协作', // 立即协作
    SearchType: '搜索类型', // 搜索类型
    Company: '企业', // 企业
    SearchCompanies: '查找企业', // 查找企业
    QuickCollaboration: '快速协作', // 快速协作
    ToStart: '等待开始', // 等待开始
    InProgress: '进行中', // 进行中
    Over: '已结束', // 已结束
    CollaborationTime: '协作时间', // 协作时间
    CollaborationType: '协作类型', // 协作类型
    Edit: '修改详情', // 修改详情
    StartCollaboration: '开始协作', // 开始协作
    CancelCollaboration: '取消协作', // 取消协作
    InviteCollaborators: '邀请协作方', // 邀请协作方
    JoinCollaboration: '加入协作', // 加入协作
    VideoRecord: '视频记录', // 视频记录
    NoVideo: '没有视频', // 没有视频
    VideoList: '视频列表', // 视频列表
    CompositeVideo: '合成视频', // 合成视频
    Fragment: '片段', // 片段
    Back: '收回', // 收回
    Files: '相关文件', // 相关文件
    NoFiles: '暂无协作文件', // 暂无协作文件
    File: '文件', // 文件
    From: '来自', // 来自
    Time: '时间', // 时间
    InvitesCommunicateCollaborate: 'XX邀请你通讯协作', // XX邀请你通讯协作
    HangUp: '挂断', // 挂断
    Answer: '接听', // 接听
    NoCollaboration: '暂无协作', // 暂无协作
    Accept: '接受', // 接受
    ClickAddType: '点击添加类型', // 点击添加类型
    NoCotacts: '暂无联系人', // 暂无联系人
    NoSearchResut: '暂无搜索内容', // 暂无搜索内容
    AddFriend: '添加好友', // 添加好友
    RequestAdd: '请求添加', // 请求添加
    PeopleNotHiLeiaAuth: '此用户暂无HiLeia权限，无法添加', // 此用户暂无HiLeia权限，无法添加
    CompanyNotIntroduce: '公司暂未填写介绍', // 公司暂未填写介绍
    CompanyNotAddress: '公司暂未填写地址', // 公司暂未填写地址
    Me: '我', // 我
    Refused: '已拒绝', // 已拒绝
    Refused1: '已被拒绝', // 已被拒绝
    UnknownState: '未知状态', // 未知状态
    NotJoinIsFull: '协作人数已满，无法加入，请联系邀请人', // 协作人数已满，无法加入，请联系邀请人
    More20Char: '类型最多20个字符', // 类型最多20个字符
    NoNotice: '暂无通知', // 暂无通知
    AgreedRequest: '同意了您的好友申请', // 同意了您的好友申请
    DeclinedRequest: '拒绝了您的好友申请', // 拒绝了您的好友申请
    ApplyFriend: '申请加您为好友', // 申请加您为好友
    AlreadyFriend: 'XX已经是您的好友了', // XX已经是您的好友了
    CancelAccount: '注销账户', // 注销账户
    PleaseChoose: '请选择', // 请选择
    SetSuccessfully: '设置成功', // 设置成功
    ConfirmChanges: '确认修改', // 确认修改
    Less6Char: '最少6个字符', // 最少6个字符
    PasswordNotSame: '新旧密码不能相同', // 新旧密码不能相同
    PasswordMustBeSame: '两次密码不一致', // 两次密码不一致
    PasswordChangedSucc: '修改密码成功，请重新登录', // 修改密码成功，请重新登录
    AccountCancelSucc: '账户注销成功', // 账户注销成功
    VerifySendSucc: '验证码发送成功', // 验证码发送成功
    Cancelled: '已取消', // 已取消
    Undetermined: '未确定', // 未确定
    Confirmed: '已确定', // 已确定
    Solved: '已解决', // 已解决
    Unsolved: '未解决', // 未解决
    NotJoined: '未加入', // 未加入
    InMeeting: '在会议中', // 在会议中
    LeaveMeeting: '离开会议', // 离开会议
    ToInitiate: '发起', // 发起
    NoVideoRecord: '暂无视频记录', // 暂无视频记录
    NoCollaborationDocs: '暂无协作文件', // 暂无协作文件
    More32Members: '最多XX位成员同时通讯协作', // 最多XX位成员同时通讯协作
    More15ChineseOr30Char: '最多可以输入15个汉字字符或者30个英文字母', // 最多可以输入15个汉字字符或者30个英文字母
    Less1Member: '请至少选择一个联系人', // 请至少选择一个联系人
    More50MFile: '文件超过50M, 无法上传', // 文件超过50M, 无法上传
    NetworkErrorTryAgain: '网络异常，请重试', // 网络异常，请重试
    TimeUnavailable: '开始时间不能晚于结束时间', // 开始时间不能晚于结束时间
    TimeUnavailableOfLessthan: '开始时间不能早于当前时间', // 开始时间不能早于当前时间
    CollaboratorsFullNotJoin: '协作人数已满，无法加入，请联系邀请人', // 协作人数已满，无法加入，请联系邀请人
    AddFriendSucc: '请求添加好友申请成功', // 请求添加好友申请成功
    ConfirmHasMember: '请选择邀请成员后确定', // 请选择邀请成员后确定
    Less2CharOfName: '姓名至少2个字符', // 姓名至少2个字符
    ResolvingInviteLink: '正在解析邀请链接', // 正在解析邀请链接Resolving invite link
    NotOperateOfLogout: '用户已注销，无法操作', // 用户已注销，无法操作
    UnknownMistake: '未知错误', // 未知错误
  },
  calling: {
    Camera: '摄像头', // 摄像头
    Microphone: '麦克风', // 麦克风
    Speaker: '扬声器', // 扬声器
    Sticker: '万事贴', // 万事贴
    Arrow: '箭头', // 箭头
    Color: '颜色', // 颜色
    Revoke: '撤销', // 撤销
    StickerImage: '贴图', // 贴图
    LaserPointer: '激光笔', // 激光笔
    FreezeScreen: '冻屏', // 冻屏
    WhiteBoard: '白板', // 白板
    Size: '大小', // 大小
    FreezingOf: 'XX正在冻屏中', // XX正在冻屏中
    WhiteBoardOf: 'XX正在白板中', // XX正在白板中
    ScreenShare: '屏幕共享', // 屏幕共享
    Members: '成员', // 成员
    Annotator: '标注者', // 标注者
    GrantAnnotationPermissions: '授予标注权限', // 授予标注权限
    More: '更多', // 更多
    CloseVideo: '关闭视频', // 关闭视频
    DesignatedHost: '指定主持人', // 指定主持人
    Remove: '移除', // 移除
    designateHostOf: '你指定 XX 为主持人', // 你指定XX为主持人
    designatedHostOfMe: '你已被指定为主持人', // 你已被指定为主持人
    grantedAnnotationPermissionOfMe: '你已被授予标注权限', // 你已被授予标注权限
    rejectsAnnotationPermission: '主持人拒绝标注权限申请', // 主持人拒绝标注权限申请
    revokedAnnotationPermission: '你的标注权限被取消', // 你的标注权限被取消
    FreezeScreenSaved: '冻屏已保存', // 冻屏已保存
    WhiteBoardScreenSaved: '白板已保存', // 白板已保存
    InvitationLinkCopied: '邀请链接已复制', // 邀请链接已复制
    GrantingAnnotationPermissionSucc: '授予标注权限成功', // 授予标注权限成功
    CancelAnnotationPermissionSucc: '取消标注权限成功', // 取消标注权限成功
    GrantingAnnotationPermission: '授予标注权限', // 授予标注权限
    CancelAnnotationPermission: '取消标注权限', // 取消标注权限
    ApplyLabelingPermission: '标注功能需要授权才能使用，是否申请权限？', // 标注功能需要授权才能使用，是否申请权限？
    AppliesLabelingPermissionOf: 'XX申请标注权限', // XX申请标注权限
    TurnOnScreenSharingException: '开启屏幕共享异常', // 开启屏幕共享异常
    PleaseCheckSystemAuth: 'MAC系统请检查系统设置的安全与隐私设置屏幕共享权限。Windows系统请选择相应的窗口进行共享', // MAC系统请检查系统设置的安全与隐私设置屏幕共享权限。Windows系统请选择相应的窗口进行共享
    GotIt: '知道了', // 知道了
    sharingScreen: 'hileia-web.hiarcloud.com正在共享您的屏幕', // hileia-web.hiarcloud.com正在共享您的屏幕。
    StopSharing: '停止共享', // 停止共享
    Hide: '隐藏', // 隐藏
    EndCollaboration: '结束协作', // 结束协作
    LeaveCollaborationToast: '离开协作：仅自己挂断，系统会指定新的主持人', // 离开协作：仅自己挂断，系统会指定新的主持人
    EndCollaborationToast: '结束协作：所有人员将被挂断', // 结束协作：所有人员将被挂断
    LeaveCollaboration: '离开协作', // 离开协作
    Mute: '静音', // 静音
    CameraAndShareNotUseOnSameTime: '屏幕共享和摄像头视频无法同时使用', // 屏幕共享和摄像头视频无法同时使用
    TurnoffCameraAndOnShare: '是否关闭摄像头并开启屏幕共享', // 是否关闭摄像头并开启屏幕共享
    TurnoffShareAndOnCamera: '是否关闭屏幕共享并开启摄像头', // 是否关闭屏幕共享并开启摄像头
    SureShare: '屏幕共享时，通话中协作方将看到您的任意操作，确认进行共享？', // 屏幕共享时，通话中协作方将看到您的任意操作，确认进行共享？
    HungUpOfLeaveCollaboration: '离开协作，协作将被挂断', // 离开协作，协作将被挂断
    SureLeave: '确定离开', // 确定离开
    RTCRoomAbnormal: '进入RTC房间异常', // 进入RTC房间异常
    MicrophoneAbnormal: '麦克风功能异常', // 麦克风功能异常
    CameraAbnormal: '摄像头功能异常', // 摄像头功能异常
    RefreshPage: '请刷新当前页面，避免音视频通讯功能出现问题。请务必保证系统和浏览器的麦克风、摄像头以及屏幕录制的权限为"允许"状态，否则会导致通讯功能异常。', // 请刷新当前页面，避免音视频通讯功能出现问题。请务必保证系统和浏览器的麦克风、摄像头以及屏幕录制的权限为"允许"状态，否则会导致通讯功能异常。
    ObtainCameraPermissionsFailed: '打开摄像头失败，请允许网站获取摄像头权限，或检查是否有摄像头设备，或者检查摄像头是否被占用。', // 打开摄像头失败，请允许网站获取摄像头权限，或检查是否有摄像头设备，或者检查摄像头是否被占用。
    ObtainAudioPermissionsFailed: '打开麦克风失败，请允许网站获取麦克风权限，或检查是否有麦克风设备，或者检查麦克风是否被占用。', // 打开麦克风失败，请允许网站获取麦克风权限，或检查是否有麦克风设备，或者检查麦克风是否被占用
    LaserPointerUsing: '当前视频源已被激光笔功能占用，请关闭激光笔功能后重试', // 当前视频源已被激光笔功能占用，请关闭激光笔功能后重试
    MoreFunctionNotUseOfSameTime: '屏幕共享、激光笔、冻屏等功能无法共同使用，请关闭正在使用的功能后重试', // 屏幕共享、激光笔、冻屏等功能无法共同使用，请关闭正在使用的功能后重试
    OtherNotSupportFunction: '对方设备暂不支持该功能', // 对方设备暂不支持该功能
    WebNotSupportFunction: '网页端暂时不支持万事贴标注和白板功能。您可以', // 网页端暂时不支持万事贴标注和白板功能。您可以
    DownloadWinClient: '下载Windows客户端', // 下载Windows客户端
    Use: '使用', // 使用
    CollaborativeMember: '协作成员', // 协作成员
    CollaborativeFile: '协作文件', // 协作文件
    Call: '呼叫', // 呼叫
    RemovedMember: '您已移除"XX"', // 您已移除"XX"
    RemovalFailedTryAgain: '移除失败，请重试', // 移除失败，请重试
    CancelAnnotationPermissionFailed: '取消标注权限失败，请重试', // 取消标注权限失败，请重试
    GrantAnnotationPermissionFailed: '授予标注权限失败，请重试', // 授予标注权限失败，请重试
    SpecifyHostFailed: '指定主持人失败，请重试', // 指定主持人失败，请重试
    TurnoffLaserPointerTryAgain: '该用户视频源已被激光笔功能占用，请关闭激光笔功能后重试', // 该用户视频源已被激光笔功能占用，请关闭激光笔功能后重试
    AddMemberFormMember: '可在“成员”中添加协作人员', // 可在“成员”中添加协作人员
    EnteringCollaboration: '正在进入协作中', // 正在进入协作中
    ScreenSharing: '屏幕共享中', // 屏幕共享中
  },
  addressBook: {
    Contacts: '通讯录', // 通讯录
    CompanyProfile: '公司介绍', // 公司介绍
    CompanyAddress: '公司地址', // 公司地址
    peopleOf: 'XX人', // X人
    PhoneNumber: '电话', // 电话
    Phone: '电话', // 电话
    Mail: '邮箱', // 邮箱
    NotAddFriendOfExist: '已添加好友不可重复添加', // 已添加好友不可重复添加
  },
  notify: {
    ViewNotifications: '查看全部通知', // 查看全部通知
    FriendNotifications: '好友通知', // 好友通知
    CollaborationNotifications: '协作通知', // 协作通知
    SystemNotifications: '系统通知', // 系统通知
    InvitesQuickCollaborationOf: 'XX邀您参加快速协作', // XX邀您参加快速协作
  },
  personSetting: {
    PersonalInfo: '个人资料', // 个人资料
    Name: '姓名', // 姓名
    Company: '公司', // 公司
    Position: '职位', // 职位
    AccountSafety: '账户安全', // 账户安全
    ChangePassword: '修改密码', // 修改密码
    OldPassword: '旧密码', // 旧密码
    PleaseEnter: '请输入', // 请输入
    PleaseEnterOldPassword: '请输入旧密码', // 请输入旧密码
    NewPassword: '新密码', // 新密码
    EnterNewPassword: '请输入新密码', // 请输入新密码
    ConfirmAgain: '再次确认', // 再次确认
    ConfirmPassword: '请确认密码', // 请确认密码
    GeneralSettings: '常规设置', // 常规设置
    Definition: '清晰度', // 清晰度
    JoinCollaborativeMute: '加入协作静音', // 加入协作静音
    SignOut: '退出登录', // 退出登录
    Approved1: '已被同意', // 已被同意
    Approved2: '已同意', // 已同意
    InviteParty: '邀您参加', // 邀您参加
    Cancelled: '取消了', // 取消了
    Closed: '关闭了', // 关闭了
    BeRemoved: '将你移出', // 将你移出
    UploadFileTo: '上传附件到', // 上传附件到
    Update: '更新了', // 更新了
    LabelAuth: '标注权限申请', // 标注权限
    ApplyLabelAuth: '标注权限申请', // 标注权限申请
    ApplyLabelAuthInfo: '若开启，协作时，成员需要向主持人申请才能使用激光笔、万事贴、冻屏、白板涂鸦功能。', // 若开启，协作时，成员需要向主持人申请才能使用激光笔、万事贴、冻屏、白板涂鸦功能
    About: '关于', // 关于
  },
  rtc: {
    RTCClientNotExist: 'RTC客户端不存在', // RTC客户端不存在
    WebOnlySupportRTC: 'WEB端只支持声网RTC引擎', // WEB端只支持声网RTC引擎
  },
  mqtt: {
    CollaborationClosed: '本次协作已关闭', // 本次协作已关闭
    RejectedCollaborationOfNotRTC: '当前协作的RTC类型不是声网，已取消本次协作', // 当前协作的RTC类型不是声网或LeiaRTC，已取消本次协作
    AccountLoginOfAntherDevice: '您的账号已在其他设备或新页面登录', // 您的账号已在其他设备或新页面登录
    ReconnectingIMService: '正在重新连接IM服务中', // 正在重新连接IM服务中
    LeaveCollaborationOfDisconnected: '与IM服务器断开，已离开协作。', // 与IM服务器断开，已离开协作。
    AlwaysConnected: '（始终处于连接中？）', // （始终处于连接中？）
    PleaseClickHere: '请点击此处', // 请点击此处
    ServiceConnectionSucc: '服务连接成功！', // 服务连接成功！
    UserInfoInvalid: '用户信息失效，请重新登录', // 用户信息失效，请重新登录
    BeenRemoved: '你已被移除', // 你已被移除
    OperationFailedTryAgain: '操作失败，请重试', // 操作失败，请重试
    InvitesCollaboration: 'XX邀请你参加远程协作', // XX邀请你参加远程协作
    hostHasMutedYou: '主持人已将您静音', // 主持人已将您静音
  },
  main: {
    SwitchedOrNotLogin: '用户已切换或未登录', // 用户已切换或未登录
    RejoinCollaborationOfDisconnected: '网络连接不可用，请重新加入协作', // 网络连接不可用，请重新加入协作
    InternetUnavailable: '网络连接不可用', // 网络连接不可用
    Refresh: '刷新', // 刷新
    NetworkRecovery: '网络恢复', // 网络恢复
    RefreshPageAvoidProblems: '请刷新当前页面，避免音视频通讯功能出现问题。', // 请刷新当前页面，避免音视频通讯功能出现问题。
  },
  global: {
    Member: '普通成员', // 普通成员
    Label: '标注', // 标注
    Departed: '已离开', // 已离开
    Timedout: '已超时', // 已超时
    Offline: '已离线', // 已离线
    OtherBusy: '对方忙', // 对方忙
    Refused: '已拒绝', // 已拒绝
  },
  inviteLink: {
    CollaborationCopied: '协作信息已复制', // 协作信息已复制
    InvitesCollaborateUseHiLeia: 'XX 邀请您使用 HiLeia 参加协作', // XX 邀请您使用 HiLeia 参加协作
    CollaborationCopyFailed: '协作信息复制失败', // 协作信息复制失败
  },
  warn: {
    SelectAndContinue: '正在进行授权，请选择后再继续操作', // 正在进行授权，请选择后再继续操作
    GrantMicrophoneAuthWarning: '请授予麦克风使用权限，否则音频通话会异常', // 请授予麦克风使用权限，否则音频通话会异常
  },
  logout: {
    Continue: '继续', // 继续
    CancelAccount: '申请注销HiLeia账户', // 申请注销HiLeia账户
    CanelHiLeiaMessage: '注销HiLeia账户后，您将无法继续使用HiLeia，但该账号如注册了亮风台其他应用将仍可继续使用。', // 注销HiLeia账户后，您将无法继续使用HiLeia，但该账号如注册了亮风台其他应用将仍可继续使用。
    BeforeCanelMessage: '注销前，我们将会进行如下检查，以保证您的账户安全：', // 注销前，我们将会进行如下检查，以保证您的账户安全：
    VerifyIdentity: '核验您的身份', // 核验您的身份
    AccountValidState: '审核账户是否处于有效、合规的状态', // 审核账户是否处于有效、合规的状态
    CancelHiLeiaMessage: '注销HiLeia账户将会产生如下影响：', // 注销HiLeia账户将会产生如下影响：
    NotLogInAndUseHiLeia: '无法登录和使用HiLeia', // 无法登录和使用HiLeia
    NotAccessFriendAndCocData: '无法访问账户内此前的所有聊天记录、所有协作方和好友', // 无法访问账户内此前的所有聊天记录、所有协作方和好友
    NotAccessHistoryData: '无法访问历史协作及相关的附件，但您上传的文件因协作成员共享将会被保留其他人可以访问', // 无法访问历史协作及相关的附件，但您上传的文件因协作成员共享将会被保留其他人可以访问
    NotAccessAndSaveARData: '无法访问和复现保存的AR标注数据', // 无法访问和复现保存的AR标注数据
    ReadAndKnow: '我已阅读并知晓', // 我已阅读并知晓
    HiLeiaCancelAgreement: '《HiLeia用户账户注销协议》', // 《HiLeia用户账户注销协议》
    ConfirmContinue: '确认并继续', // 确认并继续
    LeavingHiLeiaMessage: '您即将离开HiLeia，我们非常不舍。同时想了解您注销账号的原因，以便我们不断地提升产品服务，期待您再次使用。', // 您即将离开HiLeia，我们非常不舍。同时想了解您注销账号的原因，以便我们不断地提升产品服务，期待您再次使用。
    SecurityPrivacyIssues: '安全/隐私问题', // 安全/隐私问题
    NotResolveIssues: '无法解决场景问题', // 无法解决场景问题
    BadExperience: '产品使用体验差', // 产品使用体验差
    ExcessiveCost: '费用过高', // 费用过高
    TallSuggestAndProblem: '说说你的建议或遇到的问题', // 说说你的建议或遇到的问题
    VerifySended: '验证码已发送至您的手机号', // 验证码已发送至您的手机号
    ConfirmCancel: '确认注销账户', // 确认注销账户
    VerifyNotEmpty: '验证码不能为空', // 验证码不能为空
    IncorrectVerify: '验证码位数不正确', // 验证码位数不正确
    LogoutSucc: '注销成功', // 注销成功
    NotProvideService: '很遗憾，亮风台无法继续为您提供HiLeia服务，感谢您的使用！', // 很遗憾，亮风台无法继续为您提供HiLeia服务，感谢您的使用！
    Reacquire: '重新获取', // 重新获取
    Valid15M: '15分钟内有效', // 15分钟内有效
  }
}
